import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGroupGochiMenusData = params =>
  axios.get(`${API_HOST}/groupMenus`, { params, withCredentials: true });

export const getGroupGochiMenuDetailData = groupMenuId =>
  axios.get(`${API_HOST}/groupMenus/${groupMenuId}`, { withCredentials: true });

export const addGroupGochiMenuData = params =>
  axios.post(`${API_HOST}/groupMenus`, params, { withCredentials: true });

export const editGroupGochiMenuData = (groupMenuId, params) =>
  axios.put(`${API_HOST}/groupMenus/${groupMenuId}`, params, {
    withCredentials: true
  });

export const deleteGroupGochiMenuData = groupMenuId =>
  axios.delete(`${API_HOST}/groupMenus/${groupMenuId}`, {
    withCredentials: true
  });

export const addGroupGochiMenuImageData = (groupMenuId, params) =>
  axios.post(`${API_HOST}/groupMenus/${groupMenuId}/image`, params, {
    withCredentials: true
  });
